import { message } from "antd";
import { AxiosError } from "axios";
import { HTTP_STATUS } from "../commons/constants/enum";

export const showMessage = (error: AxiosError, commonMessage?: string ): void => {
  if (error?.response?.status === HTTP_STATUS.NOT_MODIFIED) {
    message.error('Your tour data is expired, please reload page.');
  } else {
    if (commonMessage) {
      message.error(commonMessage);
    } else {
      message.error(error?.message);
    }
  }
};
